<div mat-dialog-title class="title">
  <div class="flex-align">
    <div class="title-text">
      @if (description) {
      <span class="description">
        <ng-container *ngTemplateOutlet="description"></ng-container>
      </span>
      } @if (headline) {
      <h2>
        <ng-container *ngTemplateOutlet="headline"></ng-container>
      </h2>
      }
    </div>
    @if (closable) {
    <a mat-dialog-close class="close">
      <mat-icon class="close__icon">close</mat-icon>
    </a>
    }
  </div>
</div>
<mat-dialog-content>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</mat-dialog-content>
